module.exports = __webpack_public_path__ + "static/media/promotional_2.891e7bbc.png";